const translation = {
  createApp: 'TẠO ỨNG DỤNG',
  types: {
    all: 'Tất cả',
    chatbot: 'Chatbot',
    agent: 'Đại lý',
    workflow: 'Quy trình',
    completion: 'Hoàn thành',
  },
  duplicate: 'Sao chép',
  duplicateTitle: 'Sao chép Ứng dụng',
  export: 'Xuất DSL',
  exportFailed: 'Xuất DSL thất bại.',
  importDSL: 'Nhập tệp DSL',
  createFromConfigFile: 'Tạo từ tệp DSL',
  deleteAppConfirmTitle: 'Xóa ứng dụng này?',
  deleteAppConfirmContent:
    'Việc xóa ứng dụng là không thể đảo ngược. Người dùng sẽ không thể truy cập vào ứng dụng của bạn nữa và tất cả cấu hình và nhật ký nhắc sẽ bị xóa vĩnh viễn.',
  appDeleted: 'Ứng dụng đã bị xóa',
  appDeleteFailed: 'Không thể xóa ứng dụng',
  join: 'Tham gia cộng đồng',
  communityIntro:
    'Thảo luận với các thành viên nhóm, người đóng góp và nhà phát triển trên các kênh khác nhau.',
  roadmap: 'Xem lộ trình của chúng tôi',
  newApp: {
    startFromBlank: 'Tạo từ Trắng',
    startFromTemplate: 'Tạo từ Mẫu',
    captionAppType: 'Loại ứng dụng bạn muốn tạo?',
    chatbotDescription: 'Xây dựng một ứng dụng dựa trên trò chuyện. Ứng dụng này sử dụng định dạng câu hỏi và trả lời, cho phép nhiều vòng trò chuyện liên tục.',
    completionDescription: 'Xây dựng một ứng dụng tạo văn bản chất lượng cao dựa trên các gợi ý, như tạo bài báo, tóm tắt, dịch và nhiều hơn nữa.',
    completionWarning: 'Loại ứng dụng này sẽ không được hỗ trợ nữa.',
    agentDescription: 'Xây dựng một Đại lý thông minh có thể tự động chọn công cụ để hoàn thành các nhiệm vụ',
    workflowDescription: 'Xây dựng một ứng dụng tạo văn bản chất lượng cao dựa trên quy trình làm việc với mức độ tùy chỉnh cao. Nó phù hợp cho người dùng có kinh nghiệm.',
    workflowWarning: 'Hiện đang trong phiên bản beta',
    chatbotType: 'Phương pháp quản lý Chatbot',
    basic: 'Cơ bản',
    basicTip: 'Dành cho người mới bắt đầu, có thể chuyển sang Chatflow sau này',
    basicFor: 'DÀNH CHO NGƯỜI MỚI BẮT ĐẦU',
    basicDescription: 'Quản lý Cơ bản cho phép quản lý ứng dụng Chatbot bằng cách sử dụng các cài đặt đơn giản, mà không cần phải sửa đổi các nhắc nhở tích hợp sẵn. Nó phù hợp cho người mới bắt đầu.',
    advanced: 'Chatflow',
    advancedFor: 'Dành cho người dùng có kinh nghiệm',
    advancedDescription: 'Quản lý Quy trình quản lý Chatbot dưới dạng các quy trình làm việc, cung cấp mức độ tùy chỉnh cao, bao gồm khả năng chỉnh sửa các nhắc nhở tích hợp sẵn. Nó phù hợp cho người dùng có kinh nghiệm.',
    captionName: 'Biểu tượng và tên ứng dụng',
    appNamePlaceholder: 'Đặt tên cho ứng dụng của bạn',
    captionDescription: 'Mô tả',
    appDescriptionPlaceholder: 'Nhập mô tả của ứng dụng',
    useTemplate: 'Sử dụng mẫu này',
    previewDemo: 'Xem trước demo',
    chatApp: 'Trợ lý',
    chatAppIntro:
      'Tôi muốn xây dựng một ứng dụng dựa trên trò chuyện. Ứng dụng này sử dụng định dạng câu hỏi và trả lời, cho phép nhiều vòng trò chuyện liên tục.',
    agentAssistant: 'Trợ lý Đại lý mới',
    completeApp: 'Máy tạo văn bản',
    completeAppIntro:
      'Tôi muốn tạo một ứng dụng tạo văn bản chất lượng cao dựa trên các gợi ý, như tạo bài báo, tóm tắt, dịch và nhiều hơn nữa.',
    showTemplates: 'Tôi muốn chọn từ mẫu',
    hideTemplates: 'Quay lại chế độ lựa chọn',
    Create: 'Tạo',
    Cancel: 'Hủy',
    nameNotEmpty: 'Tên không được để trống',
    appTemplateNotSelected: 'Vui lòng chọn một mẫu',
    appTypeRequired: 'Vui lòng chọn loại ứng dụng',
    appCreated: 'Ứng dụng đã được tạo',
    appCreateFailed: 'Không thể tạo ứng dụng',
  },
  editApp: 'Chỉnh sửa Thông tin',
  editAppTitle: 'Chỉnh sửa Thông tin Ứng dụng',
  editDone: 'Thông tin ứng dụng đã được cập nhật',
  editFailed: 'Không thể cập nhật thông tin ứng dụng',
  emoji: {
    ok: 'Đồng ý',
    cancel: 'Hủy',
  },
  switch: 'Chuyển sang Quy trình Quản lý',
  switchTipStart: 'Một bản sao ứng dụng mới sẽ được tạo cho bạn và bản sao mới sẽ chuyển sang Quy trình Quản lý. Bản sao mới sẽ ',
  switchTip: 'không cho phép',
  switchTipEnd: ' chuyển lại Cơ bản Quản lý.',
  switchLabel: 'Bản sao ứng dụng sẽ được tạo',
  removeOriginal: 'Xóa ứng dụng gốc',
  switchStart: 'Bắt đầu chuyển',
  typeSelector: {
    all: 'TẤT CẢ Loại',
    chatbot: 'Chatbot',
    agent: 'Đại lý',
    workflow: 'Quy trình',
    completion: 'Hoàn thành',
  },
}

export default translation
